
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stock-list/purchase",
      function () {
        return require("private-next-pages/stock-list/purchase/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stock-list/purchase"])
      });
    }
  